import * as yup from 'yup';

type TFunction = (key: string) => string;

export const createAddEmployeeSchema = (t: TFunction) =>
  yup.object({
    fullName: yup
      .string()
      .required(t('validation.fullName.required'))
      .min(3, t('validation.fullName.min'))
      .max(30, t('validation.fullName.max')),

    pin: yup
      .string()
      .required(t('validation.pin.required'))
      .matches(/^[A-NP-Za-np-z0-9]{7}$/, t('validation.pin.invalid')),

    serialType: yup
      .object({
        label: yup.string().required(),
        value: yup.string().required(),
      })
      .required(t('validation.serialType.required')),

    serialNumber: yup
      .string()
      .required(t('validation.serialNumber.required'))
      .matches(/^\d{5,8}$/, t('validation.serialNumber.invalid'))
      .max(8, t('validation.serialNumber.max')),

    phone: yup
      .string()
      .transform(value => value.replace(/[^\d]/g, ''))
      .matches(/^\d{9}$/u, t('validation.phone.invalid'))
      .required(t('validation.phone.required')),

    position: yup
      .string()
      .required(t('validation.position.required'))
      .min(2, t('validation.position.min'))
      .max(60, t('validation.position.max')),
  });

export type AddEmployeeSchema = yup.InferType<ReturnType<typeof createAddEmployeeSchema>>;
